module.exports = __webpack_public_path__ + "img/ics_f_location_pin.8bf1f309.svg";